import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Flex } from "rebass/styled-components";

import { LabelReadOnly } from "../../../../Components/Form/Label";
import { Button } from "../../../../Components/Button";
import { LinkedAccountsViewModel } from "../../ViewModel";
import { IconWrapper, StyledEpicIcon, UnlinkButton } from "../styledComponents";
import { URLS } from "../../../../Utilities/Maps";
import { useUser } from "../../../../Hooks/useUser";
import { useIsDesktopApp } from "../../../../Hooks/useIsDesktopApp";
const { REACT_APP_BASE_URL } = process.env;
const LinkEpic = ({ buttonText }: { buttonText: string }) => {
  const { unlinkAccount } = LinkedAccountsViewModel();
  const { allstarUser } = useUser();
  const [linked, setLinked] = useState(!!allstarUser?.user?.epic?.id);

  const { isDesktop } = useIsDesktopApp();
  const isEpicSignup = allstarUser?.user?.epic?.usedForSignUp;
  const history = useHistory();
  const link = async () => {
    if (isDesktop) {
      window.parent.postMessage(
        {
          type: "openLink",
          link: `${REACT_APP_BASE_URL}${URLS.AUTH_ROUTES.EPIC}?flow=link&referrer=DESKTOP_APP`,
        },
        "*",
      );
      return;
    }
    history.push(
      `${URLS.AUTH_ROUTES.EPIC}?flow=link&referrer=CONNECTED_ACCOUNTS`,
    );
  };

  const unlink = async () => {
    await unlinkAccount({ variables: { accountType: "epic" } });
    setLinked(!linked);
  };

  return (
    <Flex pt={5} alignItems="center">
      <IconWrapper>
        <StyledEpicIcon />
      </IconWrapper>
      {linked ? (
        <Flex width="100%" style={{ gap: "8px" }} alignItems={"center"}>
          <LabelReadOnly
            label={"Epic"}
            text={allstarUser.user?.epic?.displayName}
          />
          <UnlinkButton
            size="small"
            flex={true}
            maxWidth={2}
            classification="secondary"
            onClick={() => unlink()}
            disabled={isEpicSignup}
            style={{
              cursor: isEpicSignup ? "not-allowed" : "pointer",
            }}
          >
            Unlink
          </UnlinkButton>
        </Flex>
      ) : (
        <Button
          size="small"
          flex={true}
          maxWidth={2}
          width="100%"
          classification="secondary"
          target="_blank"
          onClick={() => link()}
        >
          {buttonText}
        </Button>
      )}
    </Flex>
  );
};

export { LinkEpic };
